import Accordion from 'entities/Accordion'
import { QRCodeBuilder } from 'features/_QRCodeBuilders/QRCodeBuilder'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

export const QRCodeAccordion = () => {
  const config = useConfigStore().config?.menuConfig
  const isCC = useGlobalStore().isCCSelected

  return (
    <Accordion title='QR Code' defaultExpanded>
      <QRCodeBuilder isExtended={!isCC && config?.[getAppName(isCC)]?.isUrlExtended} />
    </Accordion>
  )
}
